import {ReportModel} from "@fedeltapointofsale/data-client";
import {Injectable, Injector} from "@angular/core";
import {StockValuationReportData} from "./stock-valuation-report.data";

@Injectable()
export class StockValuationReportModel extends ReportModel<StockValuationReportData> {
    constructor(injector: Injector) {
        super(injector, StockValuationReportData);
    }
}
